import { ButtonBase, Card, Icon, Box, Checkbox, useTheme, styled } from 'bonfire-kindling';
import Belt from 'components/Belt/Belt';

const StyledCard = styled(Card, {
  shouldForwardProp: prop => prop !== 'isExpanded' && prop !== 'isExpandable',
})(({ theme, isExpanded, isExpandable }) => ({
  border: '1px solid',
  borderColor: isExpanded ? theme.palette.primary.main : theme.palette.grey[400],
  padding: theme.spacing(2),
  marginTop: theme.spacing(3),
  '&:hover': {
    background: isExpandable ? theme.palette.hover.main : 'white',
  },
}));

const Item = ({
  isExpanded,
  isExpandable,
  isSelected,
  indeterminate,
  onExpandClick,
  removeLabel,
  addLabel,
  onChange,
  checkboxDisabled,
  cypress,
  sx,
  children,
}) => {
  const theme = useTheme();

  return (
    <StyledCard isExpanded={isExpanded} isExpandable={isExpandable} sx={sx} elevation={0}>
      <Belt>
        {isExpandable ? (
          <ButtonBase
            onClick={onExpandClick}
            sx={{
              flexGrow: 1,
              justifyContent: 'flex-start',
              textAlign: 'left',
              '&:focus': { outline: theme => `2px dotted ${theme.palette.brand.grey.charcoal}` },
            }}
          >
            <Box
              sx={{
                alignSelf: { xs: 'flex-start', md: 'center' },
                padding: theme => theme.spacing(2),
                marginRight: theme => theme.spacing(2),
                borderRadius: '3px',
                '&:hover': {
                  background: theme => theme.palette.hover.dark,
                },
              }}
            >
              <Icon
                iconName={isExpanded ? 'chevron-down' : 'chevron-right'}
                style={{
                  color: theme.palette.grey.main,
                  fontSize: '1rem',
                }}
              />
            </Box>
            {children}
          </ButtonBase>
        ) : (
          children
        )}
        <Checkbox
          checked={isSelected}
          indeterminate={indeterminate}
          onChange={onChange}
          disabled={checkboxDisabled}
          inputProps={{ 'aria-label': isSelected ? removeLabel : addLabel }}
          color="primary"
          data-cy={cypress}
          sx={{ alignSelf: { xs: 'flex-start', md: 'center' } }}
        />
      </Belt>
    </StyledCard>
  );
};

export default Item;
